import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { PlayerInternalStatuses } from '../../api/models';

export type TABLE_TYPE = Table<PlayerInternalStatuses>;

export const TABLE = 'playerInternalStatuses';
const SCHEMA = 'playerInternalStatusId';

class PlayerInternalStatusesDatabase implements DataRepository<PlayerInternalStatuses> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<PlayerInternalStatuses | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: PlayerInternalStatuses, key: Key): Promise<PlayerInternalStatuses> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: PlayerInternalStatuses[]): Promise<PlayerInternalStatuses[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<PlayerInternalStatuses[]> {
    return this.db[TABLE].toArray();
  }
}

export const PlayerInternalStatusesDB = new PlayerInternalStatusesDatabase(db);
